module.exports = __webpack_public_path__ + "static/img/part1.c88c27d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part1.png
// module id = exEz
// module chunks = 1